export default class s {
  constructor() {}
  U(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
